import(/* webpackMode: "eager", webpackExports: ["V2ResumeEditorScreen"] */ "/app/apps/platform-web/components/v2/screens/V2ResumeEditorScreen.tsx");
